import { useState } from "react";
export function useLocalStorage(key, initialValue) {
    // @ts-ignore
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (_error) {
            return initialValue;
        }
    });
    const setValue = (value) => {
        const valueToStore = value instanceof Function ? value(storedValue) : value;
        setStoredValue(valueToStore);
        localStorage.setItem(key, JSON.stringify(valueToStore));
    };
    return [storedValue, setValue];
}
//# sourceMappingURL=useLocalStorage.js.map